import React from "react";

const Spinner = () => {
  return <div className="loader">Loading...</div>;
};

export default Spinner;
